export const uk = {
    'header-caption-cpc':
        'Инструмент подбора фраз позволяет добавить ключевые фразы и минус фразы для группы объявлений',
    'header-caption-cpm': 'Инструмент подбора фраз позволяет добавить ключевые фразы для группы объявлений',
    'header-title': 'Подбор фраз',
    'help-link': 'подробнее про подбор фраз'
};
